import React from "react";
import { pluralize } from "@common/helpers/string";
import { FiltersTypes } from "@common/types/filters/general";
import { CatalogItemFilterType } from "@common/types/catalogItem";
import { useCatalogItems } from "@api/catalogItem.api";
import { BreakableText } from "@design-system/BreakableText/BreakableText";

interface CatalogItemFilterLabelProps {
    filters: Pick<FiltersTypes, "catalogItemIds" | "catalogItemFilterType">;
}

const catalogItemFilterTypeToLabel: Record<CatalogItemFilterType, string> = {
    [CatalogItemFilterType.ALL_SELECTED]: "All: ",
    [CatalogItemFilterType.ANY_SELECTED]: "Any: ",
    [CatalogItemFilterType.EXCLUDE_SELECTED]: "Exclude: ",
};

export const CatalogItemFilterLabel: React.FC<CatalogItemFilterLabelProps> = ({
    filters: { catalogItemIds, catalogItemFilterType },
}) => {
    const { items } = useCatalogItems();

    if (!catalogItemIds?.length) {
        return null;
    }

    const filterTypeWithDefault =
        catalogItemFilterType ?? CatalogItemFilterType.ANY_SELECTED;

    if (catalogItemIds.length === 1) {
        const item = items.find((i) => i.id === catalogItemIds[0]);
        return (
            <BreakableText
                text={`${catalogItemFilterTypeToLabel[filterTypeWithDefault]}${item?.name ?? catalogItemIds[0]}`}
            />
        );
    }

    return (
        <BreakableText
            text={`${catalogItemFilterTypeToLabel[filterTypeWithDefault]}${catalogItemIds.length} ${pluralize("item", catalogItemIds.length)}`}
        />
    );
};
